import coachGateway from "../angular/services/coachGateway";

class CoachInteractor {
  constructor(dataService, coachGateway) {
    this.dataService = dataService;
    this.coachGateway = coachGateway;
  }

  getCoaches() {
    return this.coachGateway.getCoaches(this.dataService.secretKey).then(response => response.coaches);
  }

  dischargeCoach(coach) {
    return this.coachGateway.dischargeCoach(this.dataService.secretKey, coach.id);
  }
}

export default CoachInteractor